import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=89c841ae&scoped=true"
import script from "./EmptyContent.vue?vue&type=script&lang=js"
export * from "./EmptyContent.vue?vue&type=script&lang=js"
import style0 from "./EmptyContent.vue?vue&type=style&index=0&id=89c841ae&prod&lang=less&scoped=true"
import style1 from "./EmptyContent.vue?vue&type=style&index=1&id=89c841ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c841ae",
  null
  
)

export default component.exports